import styled from 'styled-components';

export const InnerPanelWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  margin: 1rem;
  padding-right: 1rem;
  > * {
    min-height: 1px;
  }
`;
